import React, { useEffect, useState, type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingView from '../components/LoadingView';
import type FriendModel from '../models/FriendModel';
import api from '../services/api';
import SearchableDropdown from '../components/SearchableDropdown';

const SharedCharts: FC = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [friends, setFriends] = useState<FriendModel[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        const pullFriends = async () => {
            const { friends, success, error } = await api.getFriends();
            setFriends(friends);
            if (!success) {
                setErrorMessage(error ?? 'unknown error');
            }

            setLoading(false);
        };

        void pullFriends();
    }, []);

    return (
        <>
            <div className="text-primary text-3xl pb-4">Shared Charts</div>
            {loading && <LoadingView />}
            {!loading && errorMessage && (
                <div className="text-primary text-xl">
                    Error: {errorMessage}
                </div>
            )}
            {!loading && !errorMessage && (
                <>
                    <div className="text-primary text-center text-xl font-bold pb-4">
                        Find Charts From A Specific User
                    </div>
                    <div className="text-primary text-center pb-4">
                        Look up charts shared specifically with you by other
                        users. This requires them to have granted you permission
                        to view their charts.
                    </div>
                    <div className="mx-auto w-fit">
                        <SearchableDropdown
                            items={friends}
                            labelField="name"
                            onSelect={(friend) => {
                                navigate(
                                    `shared-charts?user=${friend.username}&id=${friend.id}`,
                                );
                            }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default SharedCharts;
